import { render, staticRenderFns } from "./RowNewSection.vue?vue&type=template&id=32406346&scoped=true&"
import script from "./RowNewSection.vue?vue&type=script&lang=js&"
export * from "./RowNewSection.vue?vue&type=script&lang=js&"
import style0 from "./RowNewSection.vue?vue&type=style&index=0&id=32406346&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32406346",
  null
  
)

export default component.exports